/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePccPatientResponse
 */
export interface CreatePccPatientResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatePccPatientResponse
     */
    pending_patient_id: string;
}

/**
 * Check if a given object implements the CreatePccPatientResponse interface.
 */
export function instanceOfCreatePccPatientResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pending_patient_id" in value;

    return isInstance;
}

export function CreatePccPatientResponseFromJSON(json: any): CreatePccPatientResponse {
    return CreatePccPatientResponseFromJSONTyped(json, false);
}

export function CreatePccPatientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccPatientResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pending_patient_id': json['pending_patient_id'],
    };
}

export function CreatePccPatientResponseToJSON(value?: CreatePccPatientResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pending_patient_id': value.pending_patient_id,
    };
}

